import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { IntlProvider, addLocaleData } from 'react-intl';
import serverVars from 'server-vars';
import { addLoginHandlers, initResetUpdateUserState } from '../utils/loginHandlers';

import { actionCreators } from '../actions';

const getBuyerHeaderClient = ({ node, store, relayEnv }) => {
    const isDesktop = serverVars.get('settings.isDesktop');

    let navPromise;

    if (isDesktop) {
        navPromise = import(
            /* webpackChunkName: "responsiveHeader" */ '../components/responsiveHeader'
        );
    } else {
        navPromise = import(/* webpackChunkName: "mobileHeader" */ '../components/mobileHeader');
    }

    navPromise.then(({ HeaderRenderer, headerRootQuery, headerInitialVariables }) => {
        const localeDataKey = serverVars.get('localeDataKey');
        const messages = serverVars.get('messages');

        if (window.ReactIntlLocaleData) {
            addLocaleData(window.ReactIntlLocaleData[localeDataKey]);
        }

        const props = {
            initialVariables: headerInitialVariables,
            environment: relayEnv,
            query: headerRootQuery,
        };

        addLoginHandlers(() => {
            store.dispatch(actionCreators.setUpdateUserState(true));
        });
        initResetUpdateUserState(() => store.dispatch(actionCreators.setUpdateUserState(false)));

        ReactDOM.hydrate(
            <IntlProvider locale={localeDataKey} messages={messages}>
                <Provider store={store}>
                    <HeaderRenderer {...props} />
                </Provider>
            </IntlProvider>,
            node
        );

        return {
            store,
            getBuyerHeaderUiState: store.getState,
        };
    });
};

export { getBuyerHeaderClient };
